/**
 * Forms elements
 */
class ME_Forms {
 constructor() {
  this.initPostCode();
  this.initHelpForm();
  this.initHelpTiles();
  this.initFixedLoginBox();
  this.checkRegisterForm();
 }

 initPostCode() {

  let unmaskedFields = $('.product-advisor__contact__fieldset.product-advisor__contact__post-code').find('[name*="post_code"], [name*="postcode"]');

  if (unmaskedFields.length) {
   unmaskedFields.attr('data-unmasked', 'true');

   unmaskedFields.keyup(function () {
    if (this.value.length == this.maxLength) {
     if ($(this).nextAll('input').length) {
      $(this).nextAll('input').eq(0).focus();
     }
    }
   });
  }

  $('[name*="post_code"], [name*="postcode"]').not('[data-unmasked="true"]').mask('00-000');
 }

 initHelpForm() {
  let helpPage = $('section.section-help');
  let loginBox = helpPage.find('.login-box');
  let loginBoxForm = loginBox.find('#userForm');
  let mobileHelpBottom = $('.mobile-help-bottom-sticky');
  let hideLoginBox = loginBox.find('.hide-form');
  let hideBtnLoginBox = loginBox.find('.hide-mobile-bottom');
  let steps = loginBoxForm.find('ul.help-form-steps li');
  let stepsList = loginBoxForm.find('ul.help-steps-list li');
  let backToForm = $('.show-form');
  let attachments = 0;

  if (mobileHelpBottom.length > 0) {
   $('footer').addClass('help-footer');
  }

  steps.find('.input').on('input', function () {
   $(this).removeClass('error')
  })

  steps.eq(0).find('button').on('click', function (e) {
   e.preventDefault();

   steps.eq(0).find('.required').each(function () {
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    let inputType = $(this).attr('type');

    if (inputType === 'email') {
     if (!emailPattern.test($(this).val())) {
      $(this).addClass('error');
     } else {
      $(this).removeClass('error');
     }
    } else if (inputType === 'text') {
     if ($(this).val().length <= 0) {
      $(this).addClass('error');
     } else {
      $(this).removeClass('error');
     }
    }
   });

   if (steps.eq(0).find('.required.error').length <= 0) {
    steps.eq(0).removeClass('active')
    stepsList.eq(0).addClass('complete')
    steps.eq(1).addClass('active')
    stepsList.eq(1).addClass('active')
   }
  })

  steps.eq(1).find('button').on('click', function (e) {
   e.preventDefault();

   if ($(window).outerWidth() < 760) {
    steps.eq(0).find('button').click();
   };

   steps.eq(1).find('.required').each(function () {
    if ($(this).val().length <= 0) {
     $(this).addClass('error')
    } else {
     $(this).removeClass('error')
    }
   });

   if (steps.eq(1).find('.required.error').length <= 0) {
    $(this).addClass('disabled')
    $(this).addClass('isLoading')
   }
  })

  $('.add-attachment').on('click', function (e) {
   e.preventDefault();
   $('.attachment').eq(attachments).fadeIn();
   attachments++
   if (attachments > 3) {
    $('.add-attachment-row').fadeOut()
   }
  })

  mobileHelpBottom.on('click', function (e) {
   e.preventDefault();
   mobileHelpBottom.addClass('is-hidden');
   loginBox.addClass('active');
  });

  hideLoginBox.on('click', (e) => {
   e.preventDefault();
   mobileHelpBottom.removeClass('is-hidden')
   loginBox.removeClass('active')
  })

  hideBtnLoginBox.on('click', (e) => {
   e.preventDefault();
   mobileHelpBottom.removeClass('is-hidden')
   loginBox.removeClass('active')
  })

  backToForm.on('click', () => {
   location.reload();
  })
 }

 initHelpTiles() {
  let helpTiles = $('section.help-tiles');

  if (!helpTiles.length) {
   return
  }

  let searchWrapper = helpTiles.find('.help-search-wrapper');
  let searchInput = searchWrapper.find('.input.search');
  let searchItems = helpTiles.find('.tile .tile__content h3');

  searchInput.on('input', function () {
   let value = $(this).val()

   if (value.length > 0) {
    searchItems.each(function () {
     var item = $(this)

     if (item.text().toLowerCase().indexOf(value.toLowerCase()) >= 0) {
      item.closest('.tile').css('display', 'flex')
     } else {
      item.closest('.tile').css('display', 'none')
     }
    })
   } else {
    $('section.help-tiles .help-content .tiles .tile').css('display', 'flex')
   }
  });
 }

 initFixedLoginBox() {
  let helpPage = $('section.section-help');
  let loginBox = helpPage.find('.login-box');

  if (!loginBox.length) {
   return
  }

  $(window).on('scroll', () => {
   let positionY = $(window).scrollTop();

   if (positionY > 25 && !loginBox.hasClass('is-fixed')) {
    loginBox.addClass('is-fixed');
    return;
   }

   if (positionY <= 25 && loginBox.hasClass('is-fixed')) {
    loginBox.removeClass('is-fixed');
   }
  });
 }

 checkRegisterForm() {
  let conferenceForm = document.querySelector('.form_register_conference');
  if (!conferenceForm) {
   return
  }
  let conferenceFormContainer = conferenceForm.querySelector('.form');
  let currentHideInput = conferenceFormContainer.querySelector('input#sector-9');
  let otherInput = conferenceFormContainer.querySelectorAll('input');

  if (currentHideInput.checked) {
   document.querySelector('.books-form').classList.add('hidden');
   document.querySelector('.school-data').classList.add('hidden');
  } else {
   document.querySelector('.books-form').classList.remove('hidden');
   document.querySelector('.school-data').classList.remove('hidden');
  }

  for (let i = 0; i < otherInput.length; i++) {
   otherInput[i].addEventListener('change', function () {
    setTimeout(function () {
     if (currentHideInput.checked) {
      document.querySelector('.books-form').classList.add('hidden');
      document.querySelector('.school-data').classList.add('hidden');
     } else {
      document.querySelector('.books-form').classList.remove('hidden');
      document.querySelector('.school-data').classList.remove('hidden');
     }
    }, 100)
   })
  }
 }
}
